module.exports = __webpack_public_path__ + "img/id-wrong-alignment.995fbbc6.png";